export class IndexOutOfBoundaryError extends Error {
  constructor() {
    super('index out of boundary')
  }
}
